import { TableCell } from "@material-ui/core";
import { formatNumber, isNull } from "App/utils/helpers";

export default function FieldTarif({ dataTarif, row }) {
  return dataTarif.map((e, index) => {
    let harga = Array.isArray(row.harga) ? row.harga : [];
    const kelas = harga.find(({ id_tarif }) => id_tarif === e.id);

    return (
      <TableCell key={`tarif-${index}`} align='left'>
        <table width='100%'>
          <tbody>
            <tr>
              <td>Harga</td>
              <td style={{ padding: "0 5px" }}>:</td>
              <td>{isNull(kelas) ? 0 : formatNumber(kelas.harga)}</td>
            </tr>
            <tr>
              <td>Harga Custom</td>
              <td style={{ padding: "0 5px" }}>:</td>
              <td>{isNull(kelas) ? 0 : formatNumber(kelas.harga_custom)}</td>
            </tr>
          </tbody>
        </table>
      </TableCell>
    );
  });
}
